'use client';

import { useTranslations } from 'next-intl';

import {
  type Listing,
  type ListingType,
  ListingTypeId,
} from '@/features/listing/types/listing-types';

import styles from './listing-address.module.scss';

interface ListingAddressProps {
  address: Listing['addressFormatted'];
  listingTypeId: Listing['listingTypeId'];
  showListingType?: boolean;
}

export default function ListingAddress(props: ListingAddressProps) {
  const {
    address,
    listingTypeId,
    showListingType = true,
  } = props;

  const listingType = ListingTypeId[listingTypeId] as ListingType;
  const translationsCard = useTranslations('listing.card.types');

  return (
    <p className={styles.listingAddress}>
      {showListingType && (
        <>
          <span>
            {translationsCard(listingType)}
          </span>
          <span className={styles.listingAddress_divider}>{' | '}</span>
        </>
      )}

      <span className={styles.listingAddress_place}>
        {address}
      </span>
    </p>
  );
}
